export default __webpack_public_path__ + "static/media/hot-mop-planter-box.1f499175.jpg";